import { useApiClient } from '@@common';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { EnvironmentClient, EnvironmentModel } from '../../api/api';

export default function useApiEnvironments(): UseQueryResult<EnvironmentModel[], Error> {
	const client = useApiClient(EnvironmentClient);
	const environments = useQuery({
		queryKey: ['environments'],
		queryFn: async () => (await client.search({})).items,
	});
	return environments;
}
